import React from 'react';
import {FormattedMessage} from "react-intl";

import SidebarHeadingTitle from "../../SidebarHeadingTitle";
import RetailersItem from "./components/RetailersItem";
import RetailerProfileItem from "./components/RetailerProfileItem";
import MerchandisingItem from "./components/MerchandisingItem";
import EikowProductsItem from "./components/EikowProductsItem";
import TeamItem from "./components/TeamItem";
import ConfigurationItem from "./components/ConfigurationItem";
import OptionItem from "./components/OptionItem";
import AccountingItem from "./components/AccountingItem";
import ComplianceItem from "./components/ComplianceItem";
import StatisticItem from "./components/StatisticItem";
import DashboardItem from "./components/DashboardItem";

function MarketplaceMenu(props) {
    return (
        <div style={{
            padding: '12px',
            marginBottom: '20px'
        }}>
            <SidebarHeadingTitle>
                <FormattedMessage id='sidebar.menu.title' />
            </SidebarHeadingTitle>
            <DashboardItem />
            <RetailerProfileItem />
            <RetailersItem />
            <MerchandisingItem />
            <StatisticItem />
            <EikowProductsItem />
            <OptionItem />
            <ConfigurationItem />
            <TeamItem />
            <AccountingItem />
            <ComplianceItem />
        </div>
    );
}

export default MarketplaceMenu;
